<template>
    <div v-if="visible" class="modal" @click.self="close">
      <div class="modal-content">
        <span class="close" @click="close">&times;</span>
        <object :data="fileUrl" type="application/pdf" width="100%" height="600px">
          <p>Tu navegador no tiene un visor de PDF. Puedes descargar el PDF para verlo: <a :href="fileUrl">Descargar PDF</a>.</p>
        </object>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      fileUrl: String,
      visible: Boolean
    },
    methods: {
      close() {
        this.$emit('update:visible', false);
      }
    }
  }
  </script>
  
  <style scoped>
  .modal {
    display: flex;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
    height: 80%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
  </style>  